import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "card-wrapper" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "success-overlay"
}
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "number-of-guesses" }

import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { getGeoGuesserById, guessGeoGuesser, getAllGeoGuesserIds } from '@/services/geoGuesser/geoGuesser.service';

import { getWc3Maps } from '@/services/wc3/wc3.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeoGuesserGuess',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const id = computed(() => Number(route.params.id));

const geo = ref<any>(null);
const maps = ref<{ id: number; name: string }[]>([]);
const allIds = ref<number[]>([]);

const selectedMapId = ref<number | null>(null);
const attempts = ref(0);
const solved = ref(false);
const feedback = ref('');
const numberOfGuesses = ref(0);

const SUCCESS_MESSAGES = [
  'Good job! You nailed it.',
  'Awesome work! You crushed it.',
  'Well done! Victory is yours.',
  'Great play! You did it.',
  'Impressive! You nailed that one.',
  'Fantastic! You’re on fire.',
  'You win! Easy peasy.',
  'EZ win 😎',
  'Victory dance time!',
  'GG! Well played.',
  'That was fast.',
  'Big brain play.',
  'Skill detected.',
  'You are built different!',
];

const imageSrc = computed(() => {
  if (!geo.value) return '';
  if (solved.value) return geo.value.images.large;
  if (attempts.value === 0) return geo.value.images.small;
  if (attempts.value === 1) return geo.value.images.medium;
  return geo.value.images.large;
});

const currentIndex = computed(() => allIds.value.indexOf(id.value));

const prevId = computed(() => {
  return currentIndex.value > 0 ? allIds.value[currentIndex.value - 1] : null;
});

const nextId = computed(() => {
  return currentIndex.value !== -1 && currentIndex.value < allIds.value.length - 1 ? allIds.value[currentIndex.value + 1] : null;
});

function getSolvedIds(): number[] {
  try {
    return JSON.parse(localStorage.getItem('geo-guesser-solved') || '[]');
  } catch {
    return [];
  }
}

function markSolved(id: number) {
  const solvedIds = getSolvedIds();
  if (!solvedIds.includes(id)) {
    solvedIds.push(id);
    localStorage.setItem('geo-guesser-solved', JSON.stringify(solvedIds));
  }
}

async function loadGeo(id: number) {
  geo.value = null;
  solved.value = false;
  feedback.value = '';
  attempts.value = 0;
  numberOfGuesses.value = 0;
  selectedMapId.value = null;

  geo.value = await getGeoGuesserById(id);
}

async function submitGuess() {
  if (!selectedMapId.value || solved.value) return;

  numberOfGuesses.value++;

  const res = await guessGeoGuesser(id.value, {
    mapId: selectedMapId.value,
  });

  if (res.correct) {
    solved.value = true;
    feedback.value = '🎉 ' + SUCCESS_MESSAGES[Math.floor(Math.random() * SUCCESS_MESSAGES.length)];
    markSolved(id.value);
  } else {
    attempts.value++;
    feedback.value = attempts.value === 1 ? 'Wrong guess. Here is a better view.' : 'Still wrong. Full image unlocked!';
  }
}

function goPrev() {
  if (prevId.value !== null) {
    router.push(`/geoguesser/${prevId.value}`);
  }
}

function goNext() {
  if (nextId.value !== null) {
    router.push(`/geoguesser/${nextId.value}`);
  }
}

watch(
  () => id.value,
  async (newId) => {
    await loadGeo(newId);
  },
  { immediate: true }
);

onMounted(async () => {
  maps.value = await getWc3Maps();
  allIds.value = await getAllGeoGuesserIds();
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (geo.value)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "game-wrapper"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (feedback.value && !solved.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "floating-alert"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(feedback.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              class: "game-card",
              elevation: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_img, {
                    src: imageSrc.value,
                    "aspect-ratio": "16/9",
                    cover: ""
                  }, null, 8, ["src"]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (solved.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("h2", null, _toDisplayString(feedback.value), 1),
                            _createElementVNode("p", null, _toDisplayString(maps.value.find((m) => m.id === selectedMapId.value)?.name), 1),
                            _createElementVNode("p", _hoisted_4, [
                              _cache[2] || (_cache[2] = _createTextVNode(" You guessed it in ", -1)),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(numberOfGuesses.value), 1),
                              _createTextVNode(" " + _toDisplayString(numberOfGuesses.value === 1 ? 'try' : 'tries') + "! ", 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (!solved.value)
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          modelValue: selectedMapId.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMapId).value = $event)),
                          items: maps.value,
                          "item-title": "name",
                          "item-value": "id",
                          label: "Guess the map!",
                          clearable: ""
                        }, null, 8, ["modelValue", "items"]),
                        _createVNode(_component_v_btn, {
                          block: "",
                          size: "large",
                          color: "primary",
                          onClick: submitGuess
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" Submit Guess ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_actions, { class: "nav-actions" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      onClick: goPrev,
                      disabled: !prevId.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-arrow-left", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/geoguesser')))
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" Back to list ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      onClick: goNext,
                      disabled: !nextId.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-arrow-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})